import MuiGrid from '../../../UI/MuiGrid/MuiGrid';

const GridProviderTroskovi = ({ data = [], isLoading }) => {
  const columns = [
    // { field: 'naziv', headerName: 'Naziv', width: 200 },
    // { field: 'cena', headerName: 'Cena koštanja', width: 200 },
    // { field: 'iznos', headerName: 'Iznos', width: 200 },
    // { field: 'opis', headerName: 'Opis', width: 400 },
    { field: 'nazivUsluge', headerName: 'Vrsta', width: 200 },
    // { field: 'naziv', headerName: 'Naziv', width: 400 },
    { field: 'jm', headerName: 'Jedinica mere', width: 120 },
    { field: 'kolicina', headerName: 'Količina', width: 120 },
    { field: 'cena', headerName: 'Cena koštanja', width: 150 },
    { field: 'iznos', headerName: 'Cena prema klijentu', width: 200 },
    { field: 'napomena', headerName: 'Napomena', width: 300 },
  ];

  return (
    <div style={{ height: '85vh', width: '99%' }}>
      <MuiGrid data={data} columns={columns} loading={isLoading} />
    </div>
  );
};

export default GridProviderTroskovi;
